module.exports = __webpack_public_path__ + "images/my-integral-icon-find.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/my-integral-icon-find.png
// module id = 884
// module chunks = 130